import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpInterceptorService } from '../http-interceptor/http-interceptor.service';

interface ExportSessionFilters {
  OnlyErrorsOrWarnings: boolean;
  OnlyZeroPrice: boolean;
  OnlyZeroKWh: boolean;
}

@Injectable()
export class OrdersService {
  ordersHistory$: Subject<OrderHistoryParams> = new Subject();

  constructor(private _http: HttpInterceptorService) {}
  getOrderHistory(params: OrderHistoryParams) {
    this.ordersHistory$.next(params);
  }

  handleError(err: any) {
    this.ordersHistory$.error(err);
  }

  fetchOrderHistory(params: OrderHistoryParams) {
    return this._http.post(
      `ChargingHistory/${params.action}/${params.id}/${params.limit}/${params.startIndex}/${params.from}/${params.to}/${params.calculateTotalPrice}`,
      params.filters || {}
    );
  }

  exportSession(locationID: number, start: number, end: number, filters: any) {
    return this._http.post(`sessions/location/${locationID}/export/${start}/${end}`, filters);
  }
}

interface OrderHistoryParams {
  action: string;
  id?: number;
  limit?: number;
  startIndex?: number;
  from?: number | string;
  to?: number | string;
  calculateTotalPrice?: string;
  filters?: any;
}
